// extracted by mini-css-extract-plugin
export var csatScore = "_iv-5";
export var header = "_iv-1";
export var panelWrapper = "_iv-2";
export var postPreview = "_iv-3";
export var rightContent = "_iv-0";
export var wrappingText = "_iv-4";